import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=08444558&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08444558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/customer-ben-bella/customer-ben-bella/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
